export default "<div class=\"text-center footer\">\n    <p>Copyright {{$root.currentYear}}. All rights reserved.</p>\n</div>\n"